import React from "react";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import pages from "../../../scripts/myga-ui";
import "./SubmitApp.css";
import {
  AGENT_INFO_V01, APP_COMPLETION_STATUS,
  APP_SECTION,
  APP_SUBMISSION,
  SOURCE_OF_FUNDS_ATTESTATION
} from "../../../scripts/constants";
import Resources from "../../../Resources/Resources";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {isValid, mygaSession} from "../../../scripts/myga-session";
import {saveValidationReport, submitApp} from "../../../scripts/sync-manager";
import {didConsent, isFL, isPathB, isPathC} from "../../../scripts/validation";
import {NassauLog} from "../../../scripts/myga-utils";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";
import {Container} from "react-bootstrap";

/**
 * A method to be called on the submission page to determine the final
 * submission path.
 * @returns {string|string|*}
 */
const getAppCompletionStatus = () => {
  // check for application started
  if (!PageManager.isApplicationStarted()) {
    return APP_COMPLETION_STATUS.notStarted;
  }

  // Check for consent available only on the final page.
  if (!didConsent()) {
    return APP_COMPLETION_STATUS.finishedIncomplete;
  }

  // check for a Path C or B condition where additional action would be needed
  // NB Path C is the same as Path B except that a producer recommendation is involved.
  if (isPathC()) {
    // Path C
    return APP_COMPLETION_STATUS.finishedAgentFollowUp;
  } else if (isPathB()) {
    // Path B, further applicant action required.
    return APP_COMPLETION_STATUS.finishedScheduleCall;
  }

  // IF we got here then the app is complete on Path A, no further action.
  return APP_COMPLETION_STATUS.finishedComplete;
}; // getAppCompletionStatus


class SubmitApp extends React.Component {
  
  getIsLicensed() {
    const agentInfo = mygaSession.getAgentInfo();
    return isValid(agentInfo) && (
        agentInfo[AGENT_INFO_V01.hasSecuritiesLicense] === "Yes" ||
        agentInfo[AGENT_INFO_V01.hasSecuritiesLicense] === "true"
    );
  }
  
  constructor(props) {
    super(props);
    
    // Load the component state from the current application
    this.state = {
      submission: mygaSession.getCurrentAppSubmission(),
      errorMessage:''
    };
  }

  submitApplication = async () => {
    NassauLog("SubmitApp.submitApp");
    
    let submission = this.state.submission;
  
    // Determine if this application includes securities.
    const questionName = isFL() ? 'sourceOfFundsForPurchaseFL' : 'sourceOfFunds'
    const finances = mygaSession.getCurrentAppFinances();
    // NassauLog(`finances: ${JSON.stringify(finances,null,2)}`);
    // NassauLog(`filter: ${JSON.stringify( PageManager.getQuestionByName(questionName)
    //     .response.constraints
    //     .filter(r=>r.isSecurity),null,2)}`);
    // NassauLog(`index: ${PageManager.getQuestionByName(questionName)
    //     .response.constraints
    //     .filter(r=>r.isSecurity)
    //     .findIndex(r=>(finances[r.key]==='Yes'))}`);
    const includesSecurities =
        PageManager.getQuestionByName(questionName)
        .response.constraints
        .filter(r=>r.isSecurity)
        .findIndex(r=>(finances[r.key]==='Yes'))>=0;
    // NassauLog(`includesSecurities: ${includesSecurities}`);
    
    // Get the agent info
    //const agentInfo = mygaSession.getAgentInfo();
    const isLicensed = this.getIsLicensed();
  
    // TODO: Include whether this is a referral or recommendation.
    
    // Determine source of funds attestation
    if (!includesSecurities) {
      submission[APP_SUBMISSION.sourceOfFundsAttestation] = SOURCE_OF_FUNDS_ATTESTATION.excludesSecurities;
    } else if (isLicensed) {
      submission[APP_SUBMISSION.sourceOfFundsAttestation] = SOURCE_OF_FUNDS_ATTESTATION.includesSecuritiesProducerLicensedYes;
    } else {
      submission[APP_SUBMISSION.sourceOfFundsAttestation] = SOURCE_OF_FUNDS_ATTESTATION.includesSecuritiesProducerLicensedNo;
    }
    // NassauLog(`sourceOfFundsAttestation: ${submission[APP_SUBMISSION.sourceOfFundsAttestation]}`);

    // save the current submission status now before calling getAppCompletionStatus();
    mygaSession.setCurrentAppSectionData(APP_SECTION.submission, submission);

    //Added our completion status to be sent with the json
    NassauLog(`appCompletionStatus: ${getAppCompletionStatus()}`);
    submission[APP_SUBMISSION.appCompletionStatus] = getAppCompletionStatus();
    
    mygaSession.setCurrentAppSectionData(APP_SECTION.submission, submission);

    NassauLog(mygaSession.getCurrentAppSectionData(APP_SECTION.submission));

    // Do not submit now if "Path B" instead wait until after an appointment is scheduled.
    if (isPathC()) {
      // save the validation report now BEFORE submitApp
      await saveValidationReport();
      // Path C means the producer will contact the applicant for additional info but
      // still OK to submit now.
      await submitApp();
    } else if (isPathB()) {
      // Path B means we will delay submission until after an appointment has been scheduled.
      NassauLog('Waiting to do the actual submission until AFTER the path-b call is scheduled.');
    } else {
      // save the validation report now BEFORE submitApp
      await saveValidationReport();
      // Path A means no appointment is needed so go ahead and submit
      await submitApp();
    }
  };
  
  onBackPressed = async () => {
  }
  
  onNextPressed = async () => {
    // 2022.05.04.ADivelbiss - the correct method to call to submit the application is submitApplication
    await this.submitApplication();
  }

  handleChange = (field) => (e) => {
    let submission = this.state.submission;
    submission[field] = e;
    this.setState({
      submission: submission,
      errorMessage:''});
  };
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      // NassauLog('form validation');
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Goals_ErrorMissingInformation
      });
      return false;
    }
  
    return true;
  };
  
  render() {
    
    return (
        
        <AppContentWrapper
            nextLabel={Resources.Strings.SubmitApp_ButtonForwardLabel}
            validateOnNext={this.validate}
            onBackPressed={this.onBackPressed}
            onNextPressed={this.onNextPressed}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>

          <form className={'needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>

          <div className="container page-section">
            <div className="row">
              <div id={pages.submit_app.html.text_please_review}
                   className="font-page-regular">
                {MYGAStrings.SubmitApp_ConsentText}
              </div>
            </div>
          </div>
          
            <Container>
              <Question
                containerClass={'pb-2 pl-sm-2'}
                data={this.state.submission}
                question={PageManager.getQuestionByName('isConsentingToDisclosure')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'pb-2 pl-sm-2'}
                data={this.state.submission}
                question={PageManager.getQuestionByName('isConsentingToSignElectronically')}
                onChange={this.handleChange}/>
            </Container>

          </form>

        </AppContentWrapper>
    
    
    );
    
  }
}

export default SubmitApp;